class CollectionFilterPrice {
  constructor() {
    this.onRangeInput = this.onRangeInput.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);
    this.init();
  }

  init() {
    document.querySelectorAll('.collection-filter-panel__price').forEach((priceBlock) => {
      this.setupPriceBlock(priceBlock);
    });
  }

  setupPriceBlock(priceBlock) {
    const minRange = priceBlock.querySelector('.collection-filter-panel__range--min');
    const maxRange = priceBlock.querySelector('.collection-filter-panel__range--max');
    const minInput = priceBlock.querySelector('.collection-filter-panel__price-input[id$="-GTE"]');
    const maxInput = priceBlock.querySelector('.collection-filter-panel__price-input[id$="-LTE"]');
    const minLabel = priceBlock.querySelector('.collection-filter-panel__price-label--min');
    const maxLabel = priceBlock.querySelector('.collection-filter-panel__price-label--max');

    if (!minRange || !maxRange || !minInput || !maxInput) return;

    const rangeMax = this.parseMoney(priceBlock.dataset.rangeMax || maxInput.dataset.max || '0');
    const minValue = this.parseMoney(priceBlock.dataset.minValue || minInput.value || '0');
    const maxValue = this.parseMoney(priceBlock.dataset.maxValue || maxInput.value || String(rangeMax));

    minRange.min = '0';
    minRange.max = String(rangeMax);
    minRange.value = String(minValue);
    maxRange.min = '0';
    maxRange.max = String(rangeMax);
    maxRange.value = String(maxValue);

    minInput.value = this.formatInputValue(minValue);
    maxInput.value = this.formatInputValue(maxValue);

    if (minLabel) minLabel.textContent = this.formatMoney(minValue, priceBlock);
    if (maxLabel) maxLabel.textContent = this.formatMoney(maxValue, priceBlock);

    minRange.removeEventListener('input', this.onRangeInput);
    maxRange.removeEventListener('input', this.onRangeInput);
    minRange.removeEventListener('change', this.onRangeChange);
    maxRange.removeEventListener('change', this.onRangeChange);

    const context = { minRange, maxRange, minInput, maxInput, minLabel, maxLabel, priceBlock };

    minRange.addEventListener('input', (event) => this.onRangeInput(event, context));
    maxRange.addEventListener('input', (event) => this.onRangeInput(event, context));
    minRange.addEventListener('change', (event) => this.onRangeChange(event, context));
    maxRange.addEventListener('change', (event) => this.onRangeChange(event, context));
  }

  onRangeInput(event, context) {
    const { minRange, maxRange, minInput, maxInput, minLabel, maxLabel, priceBlock } = context;
    let minValue = Number(minRange.value);
    let maxValue = Number(maxRange.value);

    if (minValue > maxValue) {
      if (event.target === minRange) {
        maxValue = minValue;
        maxRange.value = maxValue;
      } else {
        minValue = maxValue;
        minRange.value = minValue;
      }
    }

    minInput.value = this.formatInputValue(minValue);
    maxInput.value = this.formatInputValue(maxValue);

    if (minLabel) minLabel.textContent = this.formatMoney(minValue, priceBlock);
    if (maxLabel) maxLabel.textContent = this.formatMoney(maxValue, priceBlock);
  }

  onRangeChange(event, context) {
    const { minInput, maxInput } = context;
    minInput.dispatchEvent(new Event('input', { bubbles: true }));
    maxInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  parseMoney(value) {
    if (!value) return 0;
    const cleaned = String(value).replace(/[^\d,.-]/g, '').trim();
    if (cleaned.includes(',')) {
      const parsed = Number(cleaned.replace(/\./g, '').replace(',', '.'));
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    const parsed = Number(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  formatInputValue(value) {
    return String(value).replace('.', ',');
  }

  formatMoney(value, priceBlock) {
    const currency = priceBlock.dataset.currency || 'R$';
    const formatted = Number(value).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${currency} ${formatted}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.collectionFilterPrice = new CollectionFilterPrice();
});

document.addEventListener('shopify:section:load', () => {
  window.collectionFilterPrice?.init();
});

document.addEventListener('facets:rendered', () => {
  window.collectionFilterPrice?.init();
});
